import { PRODUCT_SEARCH_INFO } from '@@partner:graphql/shortcuts'
import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql } from '@apollo/client'

export interface PreviouslyOrderedProductsQuery {
  orderedProducts: {
    edges: Product[]
  }
}

export interface PreviouslyOrderedProductsQueryVariables {
  customer_id: GQL_ID // TODO: add typing here
  shop_id: GQL_ID
  limit?: number
  page?: number
}

export const GQL_QUERY_PREVIOUSLY_ORDERED_PRODUCTS = gql`
  query($customer_id: ID!, $shop_id: ID!, $limit: Int, $page: Int) {
    orderedProducts: previouslyOrderedProducts(
      customer_id: $customer_id
      shop_id: $shop_id
      _limit: $limit
      _page: $page
    ) {
      edges {
        ${PRODUCT_SEARCH_INFO}
      }
    }
  }
`
